export const GOOGLE_MAP_API_KEY = "AIzaSyASK7rloeUzmVtz4SGRS32csPIfffIYbGU";
